<template>
    <div class="container">
        <navigation />

        <div class="row">
            <div class="col-12 text-left">
                <a @click="$router.go(-1)" class="btn btn-link btn-back-link">&laquo; Back</a>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h1>Unlink Card</h1>
            </div>
        </div>

        <div class="row" v-if="errorMessages.length > 0">
            <div class="col-12">
                <div v-for="error in errorMessages" v-bind:key="error">
                    <div class="alert alert-danger">
                        {{error}}
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-12">
                        <p v-if="cardNumber !== ''">
                            Are you sure you wish to unlink card number <strong>{{ cardNumber }}</strong> from your account?
                        </p>
                    </div>
                </div>
                <div class="row btn-row">
                    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                        <router-link to="/cards" class="btn btn-primary btn-bellstores btn-no">
                            No
                        </router-link>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                        <button v-on:click="unlinkCard" class="btn btn-primary btn-bellstores btn-yes">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import APIResponseError from '@/models/responses/APIResponseError'
import APIRequestError from '@/models/responses/APIRequestError'

export default {
    name: 'UnlinkCard',
    dependencies: ['apiService', 'storageService'],
    data () {
        return {
            cardNumber: '',
            errorMessages: []
        }
    },
    async mounted () {
        this.cardNumber = this.$route.params.cardNumber

        if (this.cardNumber === '') {
            this.$router.replace({ name: 'ManageCards' })
        }
    },
    methods: {
        async unlinkCard (e) {
            e.preventDefault()
            this.errorMessages = []
            this.successMessages = []
            const response = await this.apiService.unlinkCard(this.cardNumber)

            if (response instanceof APIRequestError || response instanceof APIResponseError) {
                this.errorMessages.push(response.message())
                return
            }

            this.$router.push({ name: 'ManageCards' })
        }
    }
}
</script>

<style scoped lang="scss">
    .btn-row {
        margin-top: 30px;

        .btn-no,
        .btn-yes {
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/UnlinkCard.vue